<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <lg-form-const-select label="Situação:" sm="2" md="2" v-model="form.situacao"
                        :options="form.optionsFilterSituacao" @change="load()" />

                    <lg-form-input v-model="form.descricao" label="Descrição:" description=" " cols="6" sm="6" md="6" />
                    <b-col cols="1" class="mt-2">
                        <b-button id="localizarCaracteristica" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                            <b-tooltip target="localizarCaracteristica" title="Localizar"></b-tooltip>

                        </b-button>

                    </b-col>


                    <b-col cols="1" class="text-right mt-2">

                        <b-button v-if="temPrivilegioCriacao()" id="novoCaracteristica" class=" my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="mostrarModal">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" /> &nbsp;
                            </div>
                            <b-tooltip target="novoCaracteristica" title="Adicionar novo..."></b-tooltip>

                        </b-button>

                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty @row-dblclicked="clickRow">

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(situacao)="row">
                        <div :id="row.index + 'switchGrupo'">
                            <b-form-checkbox :disabled="!temPrivilegioEdicao()"  v-model="row.item.situacao" @change="alteraSituacao(row.item)"
                                name="check-button" switch size="lg" :value="1" :unchecked-value="0" />
                            <b-tooltip :target="row.index + 'switchGrupo'" title="Ativar/Desativar..."></b-tooltip>
                        </div>
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                            @click="editar(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>


                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

        <CaracteristicaForm v-if="show" @close="cancelar" :prefix="prefix + title + ' > '" :id="id" />


    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import CaracteristicaForm from "./CaracteristicaForm.vue";

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        CaracteristicaForm,
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            title: 'Característica',
            id: null,
            show: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/caracteristica`);
    },
    mounted() {
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            return [
                { key: "descricao", label: "Descrição" },
                { key: "action", label: " ", tdClass: "w-1" },

                { key: "situacao", label: " ", tdClass: "w-1" },
            ];
        },
    },
    methods: {
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);
        },
        temPrivilegioCriacao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);
        },
        async editar(item) {
            this.id = item.id;
            this.show = true;
        },
        async load() {
            this.filtro = {};
            if (this.form.descricao)
                this.filtro.descricao = this.form.descricao;

            if (this.form.situacao != null)
                this.filtro.situacao = this.form.situacao;

            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

        },
        cancelar() {
            this.id = null;
            this.show = false;
            this.load();
        },
        mostrarModal() {
            this.id = null;
            this.show = true;
        },

        async clickRow(item) {
            this.$emit("close", item);
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " a Caracteristica?",
                item.descricao.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },


    },
};
</script>